import { SxProps } from "@mui/material";

export const HeaderStyle: SxProps = {
  bgcolor: "background.paper",
  p: 2,
  height: "72px",
  width: "100%",
  borderBottom: "1px solid",
  borderColor: "divider",
};

export const CategorySelectorStyle: SxProps = {
  height: "80px",
  backgroundColor: "#ffffff",
  borderRadius: 0,
  fontSize: "22px",
  fontWeight: 600,
  "> fieldset": {
    border: "none",
  },
};

export const CategoryMenuStyle: SxProps = {
  ".MuiPaper-root": {
    boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",
    ".MuiList-root": {
      ".MuiButtonBase-root": {
        padding: "12px 16px",
        fontSize: "16px",
        fontWeight: "regular",
        ":not(:last-child)": {
          borderBottom: "1px solid",
          borderColor: "divider",
        },
      },
    },
  },
};

export const PanelWrapper: SxProps = {
  backgroundColor: "#ffffff",
  width: "300px",
  borderRight: "1px solid",
  borderColor: "divider",
  height: "100%",
};

export const PanelItemsContainer: SxProps = {
  p: 2,
  height: "100%",
  overflowY: "hidden",

  ":hover": {
    overflowY: "auto",
  },
};

export const MenuItemStyle: SxProps = {
  borderRadius: "8px",
  border: "1px solid",
  p: 2,
  cursor: "pointer",
};
